// extracted by mini-css-extract-plugin
module.exports = {"documentInfoContainer":"DocumentInfoLists_documentInfoContainer__3SM38","documentInfoItem":"DocumentInfoLists_documentInfoItem__3oXJt"};